import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import api from "@/lib/api";
import StatCard from "@/components/StatCard";
import { ShoppingBag, Package, PackageCheck, Wallet, BookOpen, ShoppingCart, ClipboardList, LayoutDashboard, BookMarked } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";

export const PARENT_NAV = [
  { to: "/parent/dashboard", label: "Overview", icon: LayoutDashboard },
  { to: "/parent/book-kits", label: "Book Kits", icon: BookMarked, highlight: true },
  { to: "/parent/catalog", label: "Shop Catalog", icon: BookOpen },
  { to: "/parent/cart", label: "Cart", icon: ShoppingCart },
  { to: "/parent/orders", label: "My Orders", icon: ClipboardList },
];

export default function ParentDashboard() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/dashboard/parent").then((r) => setData(r.data)); }, []);
  return (
    <DashboardLayout nav={PARENT_NAV} title="Parent Overview">
      <div className="sl-card p-6 mb-6 bg-gradient-to-br from-blue-600 to-emerald-500 text-white border-none">
        <div className="text-sm opacity-90">Welcome back</div>
        <div className="text-2xl font-heading font-bold mt-1">{user?.name}</div>
        <div className="text-sm mt-1">Student class: {user?.student_class || "N/A"}</div>
        <Link to="/parent/catalog" data-testid="parent-shop-cta" className="inline-block mt-4 rounded-md bg-white text-brand-blue font-semibold px-4 py-2 hover:bg-blue-50 transition-colors duration-200">Shop school-approved products</Link>
      </div>
      {data && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <StatCard testid="p-orders" label="Total Orders" value={data.total_orders} icon={ShoppingBag} tone="blue" />
          <StatCard testid="p-transit" label="In Transit" value={data.in_transit} icon={Package} tone="amber" />
          <StatCard testid="p-delivered" label="Delivered" value={data.delivered} icon={PackageCheck} tone="green" />
          <StatCard testid="p-spent" label="Total Spent" value={`₹${Number(data.total_spent).toLocaleString('en-IN')}`} icon={Wallet} tone="slate" />
        </div>
      )}
      <div className="sl-card p-6 mt-6">
        <h3 className="font-heading font-semibold text-slate-900">Recent orders</h3>
        <div className="mt-3 divide-y divide-slate-100">
          {(data?.recent_orders || []).length === 0 && <div className="text-slate-500 text-sm py-6">No orders yet. Start with the catalog.</div>}
          {(data?.recent_orders || []).map((o) => (
            <div key={o.id} className="py-3 flex items-center justify-between text-sm">
              <div>
                <div className="font-semibold">{o.order_number}</div>
                <div className="text-slate-500">{o.items.length} item(s)</div>
              </div>
              <div className="text-right">
                <div className="font-semibold">₹{Number(o.total).toLocaleString('en-IN')}</div>
                <div className="text-xs text-slate-500 capitalize">{o.delivery_status}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
}
